// extracted by mini-css-extract-plugin
module.exports = {"all-cards":"AllCards_all-cards__21dGC","all-cards__title":"AllCards_all-cards__title__20Mz_","all-cards__search":"AllCards_all-cards__search__11Mrr"};